import Image from '../../assets/Feedback/clgImage.jpg'
import { useState } from "react";
import SidebarGalleryPage from "../Main/Sidebargallery";


const Students = () => {
  const [branch, setBranch] = useState('')
  const [session, setSession] = useState('2021-22')
  const [rollNoAndName, setRollNoAndName] = useState('')
  const [comment, setComment] = useState('')

  const questions = [
    'आपके कैरियर में डिप्लोमा का योगदान',
    'संस्था में आयोजित की जाने वाली सहपाठ्यचर्या (Co-curricular) गतिविधियाँ',
    'उच्च शिक्षा के अवसर',
    'रोजगार उपलब्ध कराने में संस्था का सहयोग',
    'विद्यार्थी के दृष्टिकोण से संस्था की शिक्षण व्यवस्था'
  ]
 

  return (
    <div className="min-h-screen bg-gray-100 p-12">
      {/* Main Content */}
      <div className="flex flex-col lg:flex-row gap-10">
      <div className="md:col-span-2">
          <img
            src={Image}
            alt="कॉलेज भवन"
            width={800}
            height={300}
            className="w-full h-auto border-4 border-[#00BFA5] rounded-lg p-2 mb-10"
          />
        
      <div className="p-2 border-4 border-teal-500 rounded-lg">
            <h1 className="text-xl text-white rounded-sm bg-teal-500 font-bold p-2 mb-4">पास-आउट/ पूर्व छात्र/एल्युमिनाई के लिए फीडबैक फॉर्म</h1>
          <div className="p-4 space-y-4">
              <p>मान्यवर,</p>
              <p>सादर प्रणाम,</p>
              <p>महोदय,</p>
              <p>
                आपने शासकीय महिला पॉलिटेक्निक महाविद्यालय सीहोर (म.प्र.) में अध्ययन किया है। आपका
                अभिमत हमें हमारी शैक्षणिक गुणवत्ता सुधारने में मदद करेगा।
              </p>
            <div className="text-right">
                <p>प्राचार्य,</p>
                <p>शासकीय महिला पॉलिटेक्निक महाविद्यालय,</p>
                <p>सीहोर (म.प्र.)</p>
            </div>
          </div>
      </div>
      {/* <hr className="my-6 border-t border-gray-300" /> */}

      <div className="mt-10 mb-10 border-4 border-teal-500 p-2 rounded-lg">
        <h2 className="mb-4 text-xl font-bold bg-teal-500 text-white p-2 rounded-sm">निर्देश</h2>
        <p className="p-2">प्रिय एल्युमिनाई,</p>
        <p className="p-2">
          कृपया निम्नलिखित दिये गये विचारणीय बिन्दुओं पर अपने विचार दिए गए बिंदुओं में से किसी एक पर क्लिक
          करके देने का कष्ट करें।
        </p>
        <ol className="space-y-2 list-decimal list-inside p-4">
          <li>यदि आप समझते हैं कि यह व्यवस्था आपके द्वारा आज तक देखी गई व्यवस्थाओं में सबसे बेहतर है तो कृपया
            <span className="font-bold"> "सर्वोत्तम"</span> पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कि यह व्यवस्था आपके द्वारा देखी गई व्यवस्थाओं में सर्वोत्तम तो नहीं किन्तु
            <span className="font-bold"> "उत्तम"</span> है तो कृपया उत्तम पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कि यह व्यवस्था उत्तम तो नहीं है किन्तु खराब भी नहीं है तो कृपया
            <span className="font-bold"> "संतोषजनक"</span> पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कि यह व्यवस्था खराब है इसमें सुधार करना है तो कृपया
            <span className="font-bold"> "असंतोषजनक"</span> पर क्लिक करिये।
          </li>
          <li>यदि आप समझते हैं कुछ भी कहना नहीं चाहते है तो कृपया
            <span className="font-bold"> "कोई टिप्पणी नहीं"</span> पर क्लिक करिये।
          </li>
          <li>किसी बिन्दु के बारे में आपको कोई जानकारी नहीं है तो कृपया
            <span className="font-bold"> "कोई टिप्पणी नहीं"</span> पर पर क्लिक करिये।
          </li>
        </ol>
      </div>


      <div className="p-2 mb-4 border-4 border-teal-500 rounded-lg ">
          <h2 className="text-xl text-white bg-teal-500 font-bold p-2 rounded-sm mb-4">Feedback Form</h2>
          {/* Add your form fields here */}
          <form className="space-y-6 p-4">
            <div className="flex flex-wrap items-center gap-4">
              <label htmlFor="branch" className="whitespace-nowrap mt-4">
                आपकी शाखा है | Your Branch :
              </label>
              <select
                id="branch"
                value={branch}
                onChange={(e) => setBranch(e.target.value)}
                className="flex-grow p-2 border border-gray-300 rounded mt-4"
              >
                <option value="">--select--</option>
                <option value="cs">Computer Science</option>
                <option value="ee">Electrical Engineering</option>
              </select>
            </div>

            <div className="flex flex-wrap items-center gap-4">
              <label htmlFor="session" className="whitespace-nowrap">Session :</label>
              <select
                id="session"
                value={session}
                onChange={(e) => setSession(e.target.value)}
                className="p-2 border border-gray-300 rounded"
              >
                <option value="2021-22">2021-22</option>
                <option value="2022-23">2022-23</option>
              </select>
            </div>

            <div className="flex flex-wrap items-center gap-4">
              <label htmlFor="rollNoAndName" className="whitespace-nowrap">RollNo and Name :</label>
              <input
                type="text"
                id="rollNoAndName"
                value={rollNoAndName}
                onChange={(e) => setRollNoAndName(e.target.value)}
                placeholder="Please Write Here"
                className="flex-grow p-2 border border-gray-300 rounded"
              />
            </div>

            {questions.map((question, index) => (
              <div key={index}>
                <p className="mb-2 p-2">{index + 1} : {question}</p>
                <div className="flex flex-wrap gap-4">
                  <label className="inline-flex items-center">
                    <input type="radio" name={`question${index + 1}`} value="सर्वोत्तम" className="form-radio" />
                    <span className="ml-2">सर्वोत्तम</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input type="radio" name={`question${index + 1}`} value="उत्तम" className="form-radio" />
                    <span className="ml-2">उत्तम</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input type="radio" name={`question${index + 1}`} value="संतोषजनक" className="form-radio" />
                    <span className="ml-2">संतोषजनक</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input type="radio" name={`question${index + 1}`} value="असंतोषजनक" className="form-radio" />
                    <span className="ml-2">असंतोषजनक</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input type="radio" name={`question${index + 1}`} value="कोई टिप्पणी नहीं" className="form-radio" defaultChecked />
                    <span className="ml-2">कोई टिप्पणी नहीं</span>
                  </label>
                </div>
              </div>
            ))}

            <div>
              <label htmlFor="comment" className="block mb-2 p-2">अन्य कोई सुझाव/टिप्पणी</label>
              <textarea
                id="comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full p-2 border border-gray-300 rounded"
                rows={4}
                placeholder="Write Here"
              ></textarea>
            </div>

            <div className="flex items-center">
              <input type="checkbox" id="recaptcha" className="mr-2" />
              <label htmlFor="recaptcha" className="text-sm">
                I&apos;m not a robot
              </label>
              <img src="/placeholder.svg?height=50&width=50" alt="reCAPTCHA logo" className="w-12 h-12 ml-2" />
            </div>

            <button
              type="submit"
              className="px-4 py-2 text-black transition duration-200 bg-gray-300 rounded hover:bg-teal-500"
            >
              Submit Feedback Form फीडबैक फॉर्म जमा करें
            </button>
          </form>
        </div>
    </div>
       {/* gallery */}
        <SidebarGalleryPage></SidebarGalleryPage>
      </div>
      </div>
  );
};

export default Students;
